/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');

var react = require('react');

var useDragEvents = require('./useDragEvents.js');

var useDropZone = function useDropZone(targetRef) {
  var _useDragEvents = useDragEvents.default(targetRef, false),
      onDrop = _useDragEvents.onDrop,
      onDragOver = _useDragEvents.onDragOver,
      onDragLeave = _useDragEvents.onDragLeave;

  var _useState = react.useState(false),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      isOver = _useState2[0],
      setIsOver = _useState2[1];

  onDragOver(function (event) {
    event.preventDefault();
    setIsOver(true);
  });
  onDragLeave(function () {
    setIsOver(false);
  });
  return {
    isOver: isOver,
    onDrop: onDrop
  };
};

exports.default = useDropZone;